import dayjs from "dayjs";
import { INITIAL_SEARCH_FORM_VALUES, SearchFormInputs } from "../constants";
import { explode } from "src/utility";

const formatDate = (date: dayjs.Dayjs | undefined): string | undefined => {
  if (!date) return undefined;
  return dayjs(date).locale("en").format("YYYY-MM-DD");
};

const mapHotelsSearchToSubmitObject = (searchFormInputObject: SearchFormInputs) => {
  if (!searchFormInputObject) return null;
  const { location, checkin, checkout, rooms, guestNationality } = explode(searchFormInputObject, INITIAL_SEARCH_FORM_VALUES);
  if (!location) return null;

  const hotelCode = location.type === "hotels" ? location.value : null;
  const cityCode = location.type === "cities" ? location.value : null;

  return {
    cityCode,
    hotelCode,
    checkIn: formatDate(checkin),
    checkOut: formatDate(checkout),
    rooms,
    guestNationality: guestNationality ?? null,
    offset: 0,
  };
};

export { mapHotelsSearchToSubmitObject };
export { getCancellationInfo, getInclusionTags, getMealTypeLabel, getMandatorySupplements, getRoomBlocks, splitName, formatSupplementDescription } from "./room";
export type { CancellationInfo, RoomBlock } from "./room";
